
export default function Home() {
  return (
    <div className="grid grid-cols-5 justify-items-center bg-peach text-white mt-5 row-span-3" id="Header">
      <div className="grid grid-row-2 justify-items-center gap-10 col-start-2 col-span-3 p-6 py-52 text-brown">
        <div className="text-6xl  italic">Hello! I&apos;m<spain className="text-darkBrown font-Minya text-7xl"> Hayat Salawdeh</spain>,</div>
        <div className="text-4xl italic ">A Full-Stack Developer, based on Palestine.<br/> And I&apos;m a remote worker.</div>
      </div>
      
    </div>
  );
}
